export default function warn(s) {
  console.warn('[react-ga]', s);
}


//////////////////
// WEBPACK FOOTER
// ../~/react-ga/dist/esm/utils/console/warn.js
// module id = 180
// module chunks = 0